// @ts-check
import { forEach, groupBy, isEmpty, values } from "lodash";
import { hashGrouping } from "./util";

// Batch counterpart to updateModelWithNewTags - applies tags fetched for many
// groups at once (see useLoadGroupTags) onto their matching groupings, rather
// than one grouping at a time from the per-team tag editor.
const updateModelWithGroupTags = (state, action) => {
  const { groups } = action;

  const {
    dynamicModel: {
      groupings,
      lookups: { groupingLookup },
    },
  } = state;

  const rootGrouping = groupings?.[0];

  if (!rootGrouping || isEmpty(groupingLookup) || isEmpty(groups)) {
    return state;
  }

  let didUpdateAny = false;

  // groupingLookup is keyed by each grouping's tree-position `id`, not its
  // backing `groupId` - most groupings have id === groupId, but a real group
  // can appear more than once in the tree under a different (synthetic) id
  // (e.g. a demand team inserted as a virtual node under multiple supply
  // parents - see rebuildWithExtraDemandGrouping). The ids returned by
  // getGroupTags are real groupIds, so match on `groupId` here and update
  // every grouping that shares it, rather than assuming a single
  // groupingLookup[id] hit.
  const groupingsByGroupId = groupBy(values(groupingLookup), "groupId");

  forEach(groups, ({ id, tags }) => {
    const matchingGroupings = groupingsByGroupId[id];

    if (!isEmpty(matchingGroupings)) {
      forEach(matchingGroupings, (grouping) => {
        grouping.tags = tags;
      });
      didUpdateAny = true;
    }
  });

  if (didUpdateAny) {
    // Rehash the whole tree once, rather than rehashing ancestors for every
    // updated grouping individually - cheaper for a bulk update touching a
    // large fraction of the tree.
    hashGrouping(rootGrouping);
  }

  return {
    ...state,
  };
};

export default updateModelWithGroupTags;
